export const initialSampleCode1 = `
System.import('@amzn/aac-chrome-api-1').then(function(module) {
  var AACChromeAPI = module.default;
  var config = AACChromeAPI.getChromeConfiguration();
  config.setPageLayoutType('FOCUS');
  config.setPageHeader(new AACChromeAPI.PageHeader());
  var pageHeader = config.getPageHeader();
  pageHeader.setPageName('Hello world!');
  var objectInfo = new AACChromeAPI.ObjectInfo();
  objectInfo.setObjectType('Note');
  pageHeader.setObjectInfo(objectInfo);
  AACChromeAPI.getCommonEventTarget().addEventListener('ExitFocusView', () => {
    var config = AACChromeAPI.getChromeConfiguration();
    config.setPageLayoutType('STANDARD');
    AACChromeAPI.setChromeConfiguration(config);
  });
  AACChromeAPI.setChromeConfiguration(config);
});
`;

export const cmSampleConfig = `
System.import('@amzn/aac-chrome-api-1').then(function(module){
  var AACChromeAPI = module.default;
  var config = AACChromeAPI.getChromeConfiguration();
  config.setPageLayoutType('STANDARD');
  config.setPageHeader(new AACChromeAPI.PageHeader());

  config.setPageTitleBreadcrumb({ label: 'Campaign Health - 04/04/2022' });
  var breadcrumbItem1 = new AACChromeAPI.BreadcrumbItem();
  breadcrumbItem1.setLabel('All campaigns');
  breadcrumbItem1.setUrl('url');
  config.setBreadcrumbs([breadcrumbItem1]);

  var pivotAdGroups = new AACChromeAPI.MenuItem("AdGroups", "Ad Groups");
  var pivotPlacements = new AACChromeAPI.MenuItem("Placements", "Placements");
  var pivotNegativeTargeting = new AACChromeAPI.MenuItem("NegativeTargeting", "Negative Targeting");
  var pivotBudgetRules = new AACChromeAPI.MenuItem("BudgetRules", "Budget Rules");
  var pivotCampaignSettings = new AACChromeAPI.MenuItem("CampaignSettings", "Campaign Settings");
  var pivotHistory = new AACChromeAPI.MenuItem("History", "History");
  var pivotItems = [pivotAdGroups, pivotPlacements, pivotNegativeTargeting, pivotBudgetRules, pivotCampaignSettings, pivotHistory];
  var pivotNav = new AACChromeAPI.Menu("pivotItemsId", pivotItems);
  pivotNav.setSelectedItemId('AdGroups');
  config.setPivotNav(pivotNav);

  var pageHeader = config.getPageHeader();
  pageHeader.setPageName('Campaign Health - 04/04/2023');

  var objectInfo = new AACChromeAPI.ObjectInfo();
  objectInfo.setObjectType('Campaign');

  var attributeList = new AACChromeAPI.ItemList();

  var toggle = new AACChromeAPI.Toggle();
  toggle.setId('toggleId');
  toggle.setIsActive(true);
  attributeList.addItem(toggle);

  var keyValueStatus = new AACChromeAPI.KeyValue();
  keyValueStatus.setId('status');
  keyValueStatus.setKey('Status');
  keyValueStatus.setValue('Running');
  keyValueStatus.setValueStyle(AACChromeAPI.ValueStyle.SUCCESS);
  attributeList.addItem(keyValueStatus);

  var keyValueType = new AACChromeAPI.KeyValue();
  keyValueType.setId('type');
  keyValueType.setKey('Type');
  keyValueType.setValue('Sponsored Products - Automatic targeting');
  keyValueType.setValueStyle(AACChromeAPI.ValueStyle.DEFAULT);
  attributeList.addItem(keyValueType);

  var keyValueCountry = new AACChromeAPI.KeyValue();
  keyValueCountry.setId('country');
  keyValueCountry.setKey('Country');
  keyValueCountry.setValue('United States');
  keyValueCountry.setValueStyle(AACChromeAPI.ValueStyle.DEFAULT);
  attributeList.addItem(keyValueCountry);

  var keyValueDate = new AACChromeAPI.KeyValue();
  keyValueDate.setId('schedule');
  keyValueDate.setKey('Schedule');
  keyValueDate.setValue('Apr 1, 2020 - No end date');
  keyValueDate.setValueStyle(AACChromeAPI.ValueStyle.DEFAULT);
  attributeList.addItem(keyValueDate);

  var keyValueBudget = new AACChromeAPI.KeyValue();
  keyValueBudget.setId('budget');
  keyValueBudget.setKey('Budget');
  keyValueBudget.setValue('$1.00 - Daily');
  keyValueBudget.setValueStyle(AACChromeAPI.ValueStyle.DEFAULT);
  attributeList.addItem(keyValueBudget);

  objectInfo.setAttributes(attributeList);
  pageHeader.setObjectInfo(objectInfo);

  AACChromeAPI.setChromeConfiguration(config);
});
`;

export const cbSampleConfig = `
System.import('@amzn/aac-chrome-api-1').then(function(module){
  var AACChromeAPI = module.default;
  var config = AACChromeAPI.getChromeConfiguration();
  config.setPageLayoutType('FOCUS');
  config.setPageHeader(new AACChromeAPI.PageHeader());

  var pageHeader = config.getPageHeader();
  pageHeader.setPageName('New campaign');

  var objectInfo = new AACChromeAPI.ObjectInfo();

  var goBackLink = new AACChromeAPI.Button();
  goBackLink.setId("go_back_link");
  goBackLink.setLabel("Go back to campaigns");
  goBackLink.setButtonType(AACChromeAPI.ButtonType.LINK);
  goBackLink.setState(AACChromeAPI.ActionState.ENABLED);
  AACChromeAPI.getActionEventTarget().addEventListener(
    "go_back_link",
    () => {
      console.log("Go back link clicked");
    }
  );

  var draftButton = new AACChromeAPI.Button();
  draftButton.setId("draft_button");
  draftButton.setLabel("Save as draft");
  draftButton.setButtonType(AACChromeAPI.ButtonType.NORMAL);
  draftButton.setState(AACChromeAPI.ActionState.ENABLED);
  AACChromeAPI.getActionEventTarget().addEventListener(
    "draft_button",
    () => {
      console.log("draft button clicked");
    }
  );

  var createButton = new AACChromeAPI.Button();
  createButton.setId("create_button");
  createButton.setLabel("Launch campaign");
  createButton.setButtonType(AACChromeAPI.ButtonType.PRIMARY);
  createButton.setState(AACChromeAPI.ActionState.ENABLED);
  AACChromeAPI.getActionEventTarget().addEventListener(
    "create_button",
    () => {
      console.log("create button clicked");
    }
  );

  objectInfo.setActions([goBackLink, draftButton, createButton]);
  pageHeader.setObjectInfo(objectInfo);

  AACChromeAPI.setChromeConfiguration(config);
});
`;
